import { useContext, useState } from "react";
import { BillingInformationContext } from "../../../BillingInformationContext";
import { createPaymentMethod, initPaymentMethodCreation, logCreatePaymentMethodEvent, } from "./PaymentMethodCreate-utils";
import { useLogging } from "../../../../../Shared/hooks/useLogging/useLogging";
import { useEcommerceOrder } from "../../../../../Shared/analytics/EcommerceOrderContext";
import { useEcommerce } from "../../../../../Shared/hooks/useEcommerce/useEcommerce";
export const usePaymentMethodCreate = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();
    const { setClientSecret, setToken, setPublicKey, setCustomerCreditCards, setPaymentProcessor, customerCreditCards } = useContext(BillingInformationContext);
    const { logReactPixel, createKlaviyoEvent, datadogLog } = useLogging();
    const ecommerceOrder = useEcommerceOrder();
    const { currency, track } = useEcommerce();
    return {
        initPaymentMethodCreation: initPaymentMethodCreation(setLoading, setError, setToken, setPublicKey, setClientSecret, setPaymentProcessor, datadogLog),
        createPaymentMethod: createPaymentMethod(setError, setLoading, setCustomerCreditCards, logCreatePaymentMethodEvent(logReactPixel, createKlaviyoEvent, track, currency, ecommerceOrder), datadogLog, customerCreditCards),
        loading,
        error,
    };
};
